import React, { useEffect,useState } from "react";
import { Link } from "gatsby-plugin-react-i18next";
import { useTranslation } from "react-i18next";
import { Button, Fade } from "react-bootstrap";

const Cookies = () => {
  const { t } = useTranslation();
  const agree_cookies_name = "agree-cookies";
  const[cookieData, setCookieData] = useState<any>("1");

  const getCookie = (cname: string) => {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
      return c;
    }
    return ""
  };

  const setCookie = (cname: string, cvalue: number, exdays: number) => {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();0
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    setCookieData(false)
  };                                                         

  useEffect(() => {
    const isCookie = getCookie(agree_cookies_name);
    setCookieData(isCookie)
  }, [cookieData]);

  if(!cookieData)
  return (
    <div >
    <Fade  in={!cookieData}>
    <div className="container not-accepted">
      <div className="cookies-message d-flex align-items-center row no-gutters">
        <p className="col-md-10 col-sm-12 mb-3 mb-lg-0 small pr-4">
          {t("cookies_message")}
          <Link to="/privacy-policy">
            <u>{t("cookies_message_privacy_statement")}</u>
          </Link>
          {t("cookies_message_2")}
        </p>
        <Button
          onClick={() => {
            setCookie(agree_cookies_name, 1, 365 * 10);
          }}
          id="btn-agree-cookies"
          className="mx-2 mx-lg-0 sb-ga-click btn btn-primary btn-sm agree-cookies col"
        >
          <span>{t("cookies_message_agree")}</span>
        </Button>
      </div>
    </div>
    </Fade>
    </div>
  );

  if(cookieData)return <div/>
};

export default Cookies;
